(() => {
  const ready = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  };

  ready(() => {
    document.querySelectorAll('[data-ms-gallery]').forEach((gallery) => {
      const main = gallery.querySelector('[data-ms-main-image]');
      gallery.querySelectorAll('[data-ms-gallery-thumb]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!main) return;
          gallery.querySelectorAll('[data-ms-gallery-thumb]').forEach((thumb) => thumb.setAttribute('aria-selected', 'false'));
          button.setAttribute('aria-selected', 'true');
          main.src = button.dataset.src;
          main.alt = button.dataset.alt || main.alt;
          if (button.dataset.srcset) main.srcset = button.dataset.srcset;
        });
      });
    });

    document.querySelectorAll('[data-ms-qty-wrap]').forEach((wrap) => {
      const input = wrap.querySelector('[data-ms-qty-input]');
      wrap.querySelectorAll('[data-ms-qty]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!input) return;
          const next = Math.max(1, Number(input.value || 1) + Number(button.dataset.msQty || 0));
          input.value = next;
        });
      });
    });

    document.querySelectorAll('[data-ms-accordion]').forEach((accordion) => {
      accordion.querySelectorAll('[data-ms-accordion-toggle]').forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const item = toggle.closest('[data-ms-accordion-item]');
          if (!item) return;
          const isOpen = item.getAttribute('aria-expanded') === 'true';
          item.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        });
      });
    });

    document.querySelectorAll('[data-ms-filter-root]').forEach((root) => {
      const cards = root.querySelectorAll('[data-ms-product-card]');
      const buttons = root.querySelectorAll('[data-ms-filter]');
      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const filter = button.dataset.msFilter || 'all';
          buttons.forEach((item) => item.setAttribute('aria-pressed', item === button ? 'true' : 'false'));
          cards.forEach((card) => {
            const type = card.dataset.msProductType || 'all';
            card.hidden = filter !== 'all' && type !== filter;
          });
        });
      });
    });
  });
})();
